"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tbackground-color: ", ";\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tmargin: ", "em ", "em ", "em\n\t\t", "em;\n\tmax-height: ", "em;\n\tpadding: ", "em ", "em;\n\tposition: relative;\n\ttransition: 0.1s all linear;\n\tvertical-align: middle;\n\n\t&:hover,\n\t&:active {\n\t\topacity: 0.7;\n\t}\n"], ["\n\tbackground-color: ", ";\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tcolor: ", ";\n\tcursor: pointer;\n\tdisplay: inline-block;\n\tmargin: ", "em ", "em ", "em\n\t\t", "em;\n\tmax-height: ", "em;\n\tpadding: ", "em ", "em;\n\tposition: relative;\n\ttransition: 0.1s all linear;\n\tvertical-align: middle;\n\n\t&:hover,\n\t&:active {\n\t\topacity: 0.7;\n\t}\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: ", ";\n\tflex-wrap: wrap;\n\tmargin: -", "em;\n\n\t& > ", " {\n\t\tmargin: ", "em;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: ", ";\n\tflex-wrap: wrap;\n\tmargin: -", "em;\n\n\t& > ", " {\n\t\tmargin: ", "em;\n\t}\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getters = require("../getters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// --------------------------------------------------

var getButtonMaxHeight = R.pipe(_getters.getPaddingVertical, R.multiply(2), R.add(1.2));

// --------------------------------------------------

var getButtonTextColor = function getButtonTextColor(_ref) {
	var theme = _ref.theme,
	    type = _ref.type;
	return {
		CONFIRM: theme.colors.white,
		SELECT: theme.colors.white,
		CANCEL: theme.colors.white,
		WHITE: theme.colors.primary,
		PLAIN: theme.colors.darkgray
	}[type];
};

var getButtonBorderColor = function getButtonBorderColor(_ref2) {
	var theme = _ref2.theme,
	    type = _ref2.type;
	return {
		CONFIRM: theme.colors.primary,
		SELECT: theme.colors.secondary,
		CANCEL: theme.colors.darkgray,
		WHITE: theme.colors.primary,
		PLAIN: theme.colors.darkgray
	}[type];
};

var getButtonBackgroundColor = function getButtonBackgroundColor(_ref3) {
	var theme = _ref3.theme,
	    type = _ref3.type;
	return {
		CONFIRM: theme.colors.primary,
		SELECT: theme.colors.secondary,
		CANCEL: theme.colors.darkgray,
		WHITE: theme.colors.white,
		PLAIN: theme.colors.white
	}[type];
};

var ButtonStyled = _styledComponents2.default.div(_templateObject, getButtonBackgroundColor, R.path(["theme", "sizes", "general", "border", "radius"]), getButtonBorderColor, getButtonTextColor, _getters.getMarginVertical, _getters.getMarginRight, _getters.getMarginVertical, _getters.getMarginLeft, getButtonMaxHeight, _getters.getPaddingVertical, _getters.getPaddingHorizontal);

// --------------------------------------------------

var Button = function Button(props) {
	return _react2.default.createElement(
		ButtonStyled,
		{ type: props.type, onClick: props.onClick },
		props.text || props.children
	);
};

Button.propTypes = {
	children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	onClick: _propTypes2.default.func.isRequired,
	type: _propTypes2.default.oneOf(["SELECT", "CONFIRM", "CANCEL", "WHITE", "PLAIN"]).isRequired,
	fullWidth: _propTypes2.default.bool,
	text: _propTypes2.default.string,
	active: _propTypes2.default.bool
};

// --------------------------------------------------

var ButtonsContainer = _styledComponents2.default.div(_templateObject2, function (props) {
	return props.alignRight ? "flex-end" : "flex-start";
}, R.pipe(R.path(["theme", "sizes", "button", "gutter"]), function (x) {
	return 0.5 * x;
}), ButtonStyled, R.pipe(R.path(["theme", "sizes", "button", "gutter"]), function (x) {
	return 0.5 * x;
}));

Button.Container = ButtonsContainer;

// --------------------------------------------------

exports.default = Button;

//# sourceMappingURL=button.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/button.js
// module id = 96
// module chunks = 0